import dayjs from "dayjs";
import { Link, useNavigate } from "react-router";
import styled from "styled-components";

import { confirmUnsavedChanges } from "../../../modules/unsaved-changes";

const StyledRevisionInventory = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    height: 100%;
    overflow: hidden;

    .section-title {
        color: #172b4d;
        font-size: 0.9rem;
        font-weight: 600;
        text-transform: uppercase;
        letter-spacing: 0.03em;
    }

    ol {
        display: flex;
        flex-direction: column;
        gap: 6px;
        list-style: none;
        margin: 0;
        overflow-y: auto;
        padding: 0;
    }
`;

const StyledRevision = styled(Link)<{ $selected?: boolean }>`
    align-items: center;
    background: ${ ({ $selected }) => $selected ? "#deebff" : "#fff" };
    border: 1px solid ${ ({ $selected }) => $selected ? "#0747a6" : "#ebecf0" };
    border-radius: 6px;
    display: flex;
    justify-content: space-between;
    padding: 8px 12px;
    text-decoration: none;
    transition: background 0.15s, border-color 0.15s;

    &:hover {
        background: ${ ({ $selected }) => $selected ? "#deebff" : "#f4f5f7" };
        border-color: ${ ({ $selected }) => $selected ? "#0747a6" : "#dfe1e6" };
    }

    span {
        color: ${ ({ $selected }) => $selected ? "#0747a6" : "#172b4d" };
        font-size: 0.85rem;
        font-weight: ${ ({ $selected }) => $selected ? "600" : "400" };
    }

    .tags {
        display: flex;
        gap: 4px;

        i {
            background: #091e420f;
            border-radius: 3px;
            color: #172b4d;
            font-size: 0.7rem;
            font-style: normal;
            font-weight: 600;
            padding: 1px 5px;
            text-transform: lowercase;
        }
    }
`;

export default function RevisionInventory(props) {
    const { guard, revisions = [], selectedRevisionID } = props;
    const navigate = useNavigate();

    async function open(event, url) {
        if (!guard) return;
        event.preventDefault();
        if (await confirmUnsavedChanges(guard)) navigate(url);
    }

    return (
        <StyledRevisionInventory>
            <div className="section-title">Versions ({ revisions.length })</div>
            <ol>
                {
                    revisions.toSorted((a, b) => b.id.localeCompare(a.id)).map(
                        (revision) => (
                            <li key={ revision.id }>
                                <StyledRevision
                                    $selected={ revision.id === selectedRevisionID }
                                    onClick={ (event) => open(event, `../revisions/${ revision.id }`) }
                                    to={ `../revisions/${ revision.id }` }
                                >
                                    <span>{ dayjs(revision.createdAt).format("YYYY-MM-DD HH:mm") }</span>
                                    <div className="tags">
                                        {
                                            revision.tags.map(
                                                (tag) => (
                                                    <i key={ tag }>{ tag }</i>
                                                )
                                            )
                                        }
                                    </div>
                                </StyledRevision>
                            </li>
                        )
                    )
                }
            </ol>
        </StyledRevisionInventory>
    );
}
